import { Container, useTheme } from '@mui/material';
import { type FC, type PropsWithChildren } from 'react';
import { useLocation } from 'react-router';

import { useZustand } from '../../../../zustandStore';
import { Banner } from '../common/banner';
import { HbscTitle, Title } from '../common/title';

import AuthForm from './authForm';
import PasswordLogin from './passwordLogin/passwordLogin';
import SSOLogin from './ssoLogin';

const LoginForm: FC<PropsWithChildren> = () => {
	const theme = useTheme();
	const auth = useZustand(state => state.auth);
	const location = useLocation();
	const jsParams = new URLSearchParams(globalThis.location.search);
	const reactParams = new URLSearchParams(location.search);
	const isPlatformUser = jsParams.has('isPlatformUser') || reactParams.has('isPlatformUser');
	const TitleComp = globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? HbscTitle : Title;

	return (
		<AuthForm>
			<Container
				style={{
					width: '360px',
					padding: 0,
					border: `1px solid ${theme.palette.tsGoColor.grayLightest}`,
					backgroundColor: theme.palette.tsGoColor.white,
					marginTop: theme?.tsGoUnit.tsUnitHalf,
				}}
			>
				<Banner className="banner signin" />
				<TitleComp>
					{isPlatformUser ? 'Sign in with your existing \n\n Tradeshift credentials' : 'Authentication'}
				</TitleComp>
				{auth.login.isPasswordLogin && <PasswordLogin />}
				{auth.login.isSSOLogin && <SSOLogin />}
			</Container>
		</AuthForm>
	);
};

export default LoginForm;
